import { render, staticRenderFns } from "./ComitenteInput.vue?vue&type=template&id=52cf3055&scoped=true&"
import script from "./ComitenteInput.vue?vue&type=script&lang=js&"
export * from "./ComitenteInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cf3055",
  null
  
)

export default component.exports